<template>
    <v-app>
        <Header></Header>
        <v-content class="main-content" transition="slide-x-transition">
            <router-view :key="$route.path"></router-view>
        </v-content>
        <Footer></Footer>
    </v-app>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import axios from "axios";

    export default {
        name: 'App',
        watch: {
            '$route' (){
                this.statClient.close && this.statClient.close();
            },
        },
        created() {
            axios.get('//api.maikaelev.com/token').then(function (response) {
                window.torrentApiData = response.data;
            })
        },
        components: {
            Header,
            Footer
        }
    };
</script>
<style>
    .main-content{
        margin-top: 20px;
    }
</style>